/* src/app/system-utils/generic-datagrid/generic-datagrid.component.scss */
:host {
  font-weight: 400;
  width: 100%;
  height: 100%;
  display: flex;
}
@media (max-width: 550px) {
  app-dynamic-forms {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.view-component-body {
  width: 100%;
  height: 100%;
}
.ngx-datatable .datatable {
  height: 40vh;
}
table {
  width: 100%;
  height: 100%;
}
.mat-mdc-form-field {
  font-size: 14px;
  width: 100%;
}
td,
th {
  width: 25%;
}
::ng-deep .ngx-datatable .datatable-icon-skip:before {
  content: "q";
}
::ng-deep .ngx-datatable .sortable .sort-btn:before {
  font-family: data-table;
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-down:before {
  content: "f";
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-up:before {
  content: "e";
}
:host ::ng-deep .datatable-body-row.active .datatable-row-group {
  background-color: lightgray !important;
}
.icon {
  position: absolute;
}
.datatable-icon-down {
  top: 0px;
}
.datatable-icon-up {
  top: 40px;
}
.dragFromLeft .icon {
  left: -13px;
}
.server-scrolling {
  height: calc(50vh - 100px);
}
.server-scrolling .progress-linear {
  position: fixed !important;
  bottom: 0px;
}
/*# sourceMappingURL=generic-datagrid.component.css.map */
